import * as config from './default/appConfig'

export const configValues = config.configValues
